import React from "react";
import IsolationPermitStepPage from "./IsolationPermitStepPage";

function RequestEnergisation(props) {
  return <IsolationPermitStepPage {...props} step="energisation_request" />;
}

export default RequestEnergisation;
